import Graphic = require("esri/Graphic");
import FeatureLayer = require("esri/layers/FeatureLayer");
import MapView = require("esri/views/MapView");
import ToolBar from "../Toolbar";
import ToolButton from "./toolButton";

// AddPushPinTool

export default class AddPushPinTool extends ToolButton {
  private eventHandler: IHandle;

  constructor(viewIn: MapView, toolbarIn: ToolBar) {
    super(viewIn, toolbarIn);
  }

  deactivateTool() {
    // console.log("addPushPinTool deactivateTool")
    if (this.eventHandler) {
      this.eventHandler.remove();
    }
    const pinLabel = document.getElementById("labelPin");
    if (pinLabel) {
      const pinLabelText: HTMLInputElement = document.getElementById("pinLabelText") as HTMLInputElement;
      if (pinLabelText) {
        pinLabelText.value = "";
      }
      pinLabel.style.visibility = "hidden";
    }

    document.body.style.cursor = "default";
  }

  // Put widgets on map view
  activateTool(event: any) {
    // console.log("AddPushPinTool start")
    try {
      this.iconDiv = event.currentTarget;

      if (this.toolbar) {
        this.toolbar.setActiveTool(this as ToolButton);
      }
      const pinLabel = document.getElementById("labelPin");
      if (this.view && pinLabel) {
        this.view.focus();
        document.body.style.cursor = "crosshair";
        pinLabel.style.visibility = "visible";

        this.eventHandler = this.view.on("click", mouseEvent => {
          mouseEvent.stopPropagation();

          const pinLabelText: HTMLInputElement = document.getElementById("pinLabelText") as HTMLInputElement;

          const pinGraphic = new Graphic({
            geometry: mouseEvent.mapPoint,
            attributes: { Label: pinLabelText.value }
          });
          const pinLayer: FeatureLayer = this.view.map.findLayerById("pinLayer") as FeatureLayer;

          pinLayer
            .applyEdits({
              addFeatures: [pinGraphic]
            })
            .catch(error => {
              console.error("Error: AddPushPinTool adding pin " + error.message);
            });
          // console.log(pinLayer);
        });
      }
    } catch (error) {
      console.error("Error: in AddPushPinTool " + +error.message);
    }
  }
}
